import { API_FIELDS_DEAL as DEAL } from '@enroller/admissions-components';

export const DEAL_FIELDS = `
  ${DEAL.programType} { value }
  ${DEAL.ID} { value }
`;
